Namespace 'VueInBackbone'

class VueInBackbone.VueComponent extends Backbone.View

  initialize:(componentName, props) ->
    @componentName = componentName
    @props = Vue.observable(@clone(props))

  render: ->
    @vueInstance = new Vue({
      el: @$el[0],
      render: (h) => h(@componentName, {props: @props})
    })
    @vueComponent = @vueInstance.$children[0]
    @

  on: (eventName, callback)->
    @handleEventForVueComponent(eventName)
    super(eventName, callback)

  handleEventForVueComponent: (eventName) ->
      wrapperView = @
      vueHandlerEvent = (args...) ->
          wrapperView.trigger(eventName, args...)
      @vueComponent.$on(eventName, vueHandlerEvent)

  remove: ->
    @vueInstance.$destroy() if @vueInstance
    super()

  update: (props) ->
    for key, value of @clone(props)
      @props[key] = value

  clone: (props) ->
    JSON.parse(JSON.stringify(props))
